export default __webpack_public_path__ + "static/media/Lincoln Heritage.704fd68a.svg";